// extracted by mini-css-extract-plugin
export default {"wrapper":"BottomButtons_wrapper__zvtva","left":"BottomButtons_left__CXMs3","right":"BottomButtons_right__Q4a6n"};